import { FunctionComponent } from 'react';
import { DraftSpecialTextConfiguration } from '@/types';
import { RendererProps } from '../ConfigurationRenderer';
import { useSpecialText } from './useSpecialText';

export const SpecialTextReadOnlyRenderer: FunctionComponent<
  RendererProps<DraftSpecialTextConfiguration>
> = ({ configuration }) => {
  const [textElement, transform] = useSpecialText(configuration);

  return textElement ? <g transform={transform}>{textElement}</g> : null;
};
